import React, { useState, useEffect } from "react";
import {Col, Container, Row} from 'react-grid-system';
import {Link, useNavigate} from "react-router-dom";
import API from "../services/api";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "./common/dataTable";
import { STATUSES, STATUSES_BG } from "../helpers/constants";


const CostSync = (props) => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false)
  const [costSyncIsRunning, setCostSyncIsRunning] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(false)
  const [startingCostSync, setStartingCostSync] = useState(false)
  const [currentFromKey, setCurrentFromKey] = useState(false)
  const [syncs, setSyncs] = useState([])
  const [nextFromKey, setNextFromKey] = useState(false)
  const [columns, setColumns] = useState([
        {
          name: 'Created at',
          cell: row => (new Date(row.createdAt).toLocaleString()),
        },
        {
          name: 'Status',
          cell: row => <span onClick={(event) => rowClicked(row)} className={"badge " + STATUSES_BG[row.syncStatus] + " span-button"}>{STATUSES[row.syncStatus]}</span>,
        },
        {
          name: 'Landed cost changes count',
          cell: row => row.landedCostChangesCount,
        },
  ]);

  let updateInterval = null;

  const loadSettings = () => {
    API.getSettings().then(async (response) => {
      setCostSyncIsRunning(!!response.data?.data?.costSyncIsRunning)
    })
  }

  const loadData = (silent = false) => {
    if (!silent) {
      setLoading(true)
    }

    API.getSyncs(rowsPerPage, currentFromKey, toast).then(response => {
      if (response.data?.errors) {
        console.log(response.data.errors);
      } else {
        setSyncs(response.data.data.Items)
      }
    }).finally(() => setLoading(false))
  }

  const rowClicked = (row) => {
    navigate(`/logs/${row.id}?back=cost-sync`);
  }

  const runCostSync = () => {
    if (startingCostSync) {
      return
    }

    setStartingCostSync(true)
    API.startCostSync().then(async (response) => {
      loadSettings()
      loadData()
    }).finally(() => {
      // clearInterval(updateInterval)
      setStartingCostSync(false)
      // loadSettings()
    })
  }

  useEffect(() => {
    loadSettings()
    loadData()
    if (!updateInterval) {
      updateInterval = setInterval(() => {
        loadSettings()
        loadData(true)
      }, 5000)
    }

    return () => {
      clearInterval(updateInterval)
    }
  }, [])

  return (
  <div className="pageContent">
      <ToastContainer />
      <Container>
        <Row>
          <Col>
            <div className="btn btn-primary">
              Back
              <Link className="stretched-link" to="/" />
            </div>
          </Col>
          {costSyncIsRunning === true && (
            <Col>
              <div>
                <h4>Cost Sync is running</h4>
              </div>
            </Col>
          )}

          {costSyncIsRunning === false && (
            <>
            <Col lg={6} md={7} xs={12}>
              <div>
                <h4>Cost Sync is not running</h4>
              </div>
            </Col>
            <Col lg={2}>
                <div className="btn btn-primary" onClick={runCostSync}>
                  Run Cost Sync
                </div>
            </Col>
            </>
          )}
        </Row>
        <Row>
          <Col offset={{lg: 1}} lg={10}>
              <DataTable
                title="Syncs"
                progressPending={loading}
                onChangePage={setCurrentFromKey}
                keyField="SK"
                paginationServer={true}
                onChangeRowsPerPage={setRowsPerPage}
                rowsPerPage={rowsPerPage}
                nextFromKey={nextFromKey}
                striped={true}
                noHeader={true}
                onRowClicked={rowClicked} 
                columns={columns}
                data={syncs}
              />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CostSync
